module.exports = __webpack_public_path__ + "static/media/Ilulissat_Ice_fjord_Greenland_credit_BBC.7a1d8013.jpg";